module.exports = __webpack_public_path__ + "img/room2.5c8da817.png";